<template>
  <div class="page"><img src="./img/map.png" alt="" @click="toPre" /></div>
</template>

<script>
import { ImagePreview } from "vant";
export default {
  name: "login",
  data() {
    return {};
  },
  methods: {
    toPre(imgUrls) {
      ImagePreview({
        images: [require("./img/map.png")],
      });
    },
  },
};
</script>

<style scoped lang="less">
.page {
  width: 100%;
  min-height: 100vh;
  img {
    width: 100%;
  }
}
</style>
